import React, { Component } from 'react';
import {connect} from 'react-redux';

import * as ActionTypes from '../actions';
import Button from '../components/Button';
import Card from '../components/Card';
import CardTitle from '../components/CardTitle';
import CardText from '../components/CardText';
import Form from '../components/Form';
import Input from '../components/Input';

import ParticipantForm from './ParticipantForm';
import ParticipantItemEditable from './ParticipantItemEditable';

const mapStateToProps = (state) => {
    return {
        items: state.items
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        addParticipantToItem: (participant, identifier) => dispatch(ActionTypes.addParticipantToItem(participant, identifier)),
        removeItem: (identifier) => dispatch(ActionTypes.removeItem(identifier))
    };
};

class CartItemEditable extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showAddParticipantForm: false,
            showRemove: false
        };
    }

    handleShowAddParticipantForm = event => {
        this.setState({
            showAddParticipantForm: true
        });
    }

    handleHideAddParticipantForm = event => {
        this.setState({
            showAddParticipantForm: false
        });
    }

    handleToggleShowRemove = event => {
        event.preventDefault();
        this.setState({
            showRemove: ! this.state.showRemove
        });
    }

    handleRemoveItem = event => {
        if (this.identifierInput.value) {
            this.props.removeItem(this.identifierInput.value);
        }
    }

    handleCopyParticipant = participant => event => {
        event.preventDefault();

        const {item, addParticipantToItem} = this.props;
        const participants = this.getAllParticipants();

        addParticipantToItem(participants[participant], item.identifier);
    }

    getAllParticipants = () => {
        const {items} = this.props;
        const participants = new Object();
        Object.values(items).forEach(function(item) {
            for (const [key, value] of Object.entries(item.participants)) {
                participants[key] = value;
            }
        });
        return participants;
    }

    getAllParticipantsWithoutDuplicates = () => {
        const {items} = this.props;
        const participants = new Object();
        Object.values(items).forEach(function(item) {
            for (const [key, value] of Object.entries(item.participants)) {
                let name = value['PERSON:VORNAME'] + ' ' + value['PERSON:NACHNAME'];

                if ( ! Object.values(participants).includes(name)) {
                    participants[key] = name;
                }
            }
        });
        return participants;
    }

    render() {
        const {items, item} = this.props;
        const {showRemove} = this.state;

        let showAdd = true;
        if (item.properties.participantsCountMax > 0) {
            showAdd = Object.keys(item.participants).length < (item.properties.participantsCountMax - item.properties.participantsCount);
        }

        const participants = this.getAllParticipantsWithoutDuplicates();

        let pricePerParticipant;
        let priceInformation = item.properties.priceInfo ? item.properties.priceInfo : undefined;
        let priceTotal;
        if (item.properties.totalPrice) {
            pricePerParticipant = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(item.properties.totalPrice);
            priceTotal = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(item.properties.totalPrice * Object.keys(item.participants).length);
        }

        return (
            <Card>

                <div class="clearfix">
                    <a class="link-reset text-dark o-25 float-right d-inline-block large px-0_5 mr-n0_5" target="_blank" href={item.properties.uri}>
                        <i class="fa fa-info-circle"></i>
                    </a>
                    <a class="link-reset text-dark o-25 float-right d-inline-block large px-0_5" href="#" onClick={this.handleToggleShowRemove}>
                        <i class="fa fa-trash"></i>
                    </a>
                    <h4 class="">{item.properties.titleOverride}</h4>
                </div>
                {showRemove && (
                    <p class="text-right">
                        <Button type="button" size="sm" theme="outline-secondary" onClick={this.handleRemoveItem}>Veranstaltung entfernen</Button>
                        <Button type="button" size="sm" theme="gray" onClick={this.handleToggleShowRemove}>Abbrechen</Button>
                    </p>
                )}
                <CardText>
                    {pricePerParticipant && (
                        <p class="text-right">
                            {pricePerParticipant} je Teilnehmer, {priceTotal} gesamt
                        </p>
                    )}
                    {priceInformation !== undefined ? (
                        <div class="w-100 d-flex">
                        <p class="w-50"></p>
                        <p class="text-right text-muted text-price-info-react w-50">
                            {priceInformation}
                        </p>
                        </div>
                    ): null}

                    <p class="kicker">Teilnehmer</p>

                    {item.participants && Object.entries(item.participants).map(([key, value]) => (
                        <ParticipantItemEditable key={key} identifier={key} itemIdentifier={item.identifier} item={item} participantIdentifier={key} participant={value} />
                    ))}

                    {this.state.showAddParticipantForm ? (
                        <ParticipantForm item={item} onSubmit={this.handleHideAddParticipantForm} onDismiss={this.handleHideAddParticipantForm} />
                    ) : (
                        <div>
                            {showAdd && (
                                Object.entries(participants).length > 0 ? (
                                    <div class="dropdown d-inline-block">
                                        <Button dropdown="1" data-toggle="dropdown" type="button" theme="gray"
                                                size="sm"><i className="fa fa-plus"></i> Teilnehmer hinzufügen</Button>
                                        <div class="dropdown-menu">
                                            <button class="dropdown-item"
                                                    onClick={this.handleShowAddParticipantForm}>Neuer Teilnehmer
                                            </button>
                                            <div class="dropdown-divider"/>
                                            {Object.entries(participants).map(([key, value]) => (
                                                <button class="dropdown-item"
                                                        onClick={this.handleCopyParticipant(key)}>{value}</button>
                                            ))}
                                        </div>
                                    </div>
                                    ) : (
                                    <div class="d-inline-block">
                                        <Button theme="gray" size="sm" onClick={this.handleShowAddParticipantForm}><i className="fa fa-plus"></i> Teilnehmer hinzufügen</Button>
                                    </div>
                                )
                            )}

                            <Input inputRef={node => this.identifierInput = node} type="hidden" value={item.identifier} name="identifier" placeholder="" />

                        </div>
                    )}
                </CardText>
            </Card>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CartItemEditable);
